import { render, staticRenderFns } from "./shckDialog.vue?vue&type=template&id=08eccc7f&scoped=true&"
import script from "./shckDialog.vue?vue&type=script&lang=js&"
export * from "./shckDialog.vue?vue&type=script&lang=js&"
import style0 from "./shckDialog.vue?vue&type=style&index=0&id=08eccc7f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eccc7f",
  null
  
)

export default component.exports